// Table style themes
export const TABLE_STYLES = {
  light1:  { headerBg: '#4472C4', headerColor: '#fff', bandedRow: '#D9E2F3', bandedCol: '#E2EFDA', firstCol: '#D9E2F3', lastCol: '#FCE4D6', totalBg: '#4472C4', totalColor: '#fff' },
  light2:  { headerBg: '#ED7D31', headerColor: '#fff', bandedRow: '#FCE4D6', bandedCol: '#FFF2CC', firstCol: '#FCE4D6', lastCol: '#D9E2F3', totalBg: '#ED7D31', totalColor: '#fff' },
  light3:  { headerBg: '#70AD47', headerColor: '#fff', bandedRow: '#E2EFDA', bandedCol: '#C6EFCE', firstCol: '#E2EFDA', lastCol: '#FFEB9C', totalBg: '#70AD47', totalColor: '#fff' },
  medium1: { headerBg: '#2F5496', headerColor: '#fff', bandedRow: '#B4C6E7', bandedCol: '#D6E4F0', firstCol: '#8FAADC', lastCol: '#B4C6E7', totalBg: '#2F5496', totalColor: '#fff' },
  medium2: { headerBg: '#C55A11', headerColor: '#fff', bandedRow: '#F4CCCC', bandedCol: '#FCE4D6', firstCol: '#E6B8B7', lastCol: '#F4CCCC', totalBg: '#C55A11', totalColor: '#fff' },
  medium3: { headerBg: '#375623', headerColor: '#fff', bandedRow: '#C4D79B', bandedCol: '#D8E4BC', firstCol: '#A9C66A', lastCol: '#C4D79B', totalBg: '#375623', totalColor: '#fff' },
  dark1:   { headerBg: '#1F3864', headerColor: '#fff', bandedRow: '#2F5496', bandedCol: '#2E75B6', firstCol: '#2F5496', lastCol: '#1F3864', totalBg: '#0F2450', totalColor: '#fff' },
  dark2:   { headerBg: '#833C0B', headerColor: '#fff', bandedRow: '#C55A11', bandedCol: '#ED7D31', firstCol: '#C55A11', lastCol: '#833C0B', totalBg: '#6B2F08', totalColor: '#fff' },
};

export const TABLE_STYLE_NAMES = Object.keys(TABLE_STYLES);

export function createTable(name, startRow, startCol, endRow, endCol, style = 'light1') {
  return {
    name,
    startRow, startCol, endRow, endCol,
    style,
    headerRow: true,
    totalRow: false,
    bandedRows: true,
    bandedCols: false,
    firstColumn: false,
    lastColumn: false,
    autoFilter: true,
    totalFunction: 'none',
    totalCol: -1,
  };
}

export function getTableStyle(tables, r, c) {
  for (const tbl of tables) {
    if (r >= tbl.startRow && r <= tbl.endRow && c >= tbl.startCol && c <= tbl.endCol) {
      const s = TABLE_STYLES[tbl.style] || TABLE_STYLES.light1;
      const isHeader = tbl.headerRow && r === tbl.startRow;
      const isTotal = tbl.totalRow && r === tbl.endRow;
      const bandedRow = tbl.bandedRows && ((r - tbl.startRow) % 2 === 1);
      const bandedCol = tbl.bandedCols && ((c - tbl.startCol) % 2 === 1);
      const firstCol = tbl.firstColumn && c === tbl.startCol;
      const lastCol = tbl.lastColumn && c === tbl.endCol;

      let bg = '';
      let color = '';
      if (isHeader) { bg = s.headerBg; color = s.headerColor; }
      else if (isTotal) { bg = s.totalBg; color = s.totalColor; }
      else if (firstCol && lastCol) { bg = s.firstCol; }
      else if (firstCol) { bg = s.firstCol; }
      else if (lastCol) { bg = s.lastCol; }
      else if (bandedRow && bandedCol) { bg = s.bandedCol; }
      else if (bandedRow) { bg = s.bandedRow; }
      else if (bandedCol) { bg = s.bandedCol; }

      return { bg, color, isHeader, isTotal, table: tbl, style: s };
    }
  }
  return null;
}

export function isInTable(tables, r, c) {
  return tables.findIndex(t => r >= t.startRow && r <= t.endRow && c >= t.startCol && c <= t.endCol);
}

export function findTableContaining(tables, r, c) {
  const idx = isInTable(tables, r, c);
  return idx >= 0 ? tables[idx] : null;
}

export function autoExpandTable(tables, r, c) {
  return tables.map(t => {
    let changed = false;
    const nt = { ...t };
    if (r >= t.startRow && r <= t.endRow && c === t.endCol + 1) {
      nt.endCol = c; changed = true;
    }
    if (c >= t.startCol && c <= t.endCol && r === t.endRow + 1) {
      nt.endRow = r; changed = true;
    }
    if (r >= t.startRow && r <= t.endRow && c === t.startCol - 1) {
      nt.startCol = c; changed = true;
    }
    if (c >= t.startCol && c <= t.endCol && r === t.startRow - 1) {
      nt.startRow = r; changed = true;
    }
    return changed ? nt : t;
  });
}

export function removeTableDuplicates(tables, tableIdx, getCellValue) {
  const t = tables[tableIdx];
  if (!t) return tables;
  const seen = new Set();
  const rowsToDelete = new Set();
  for (let r = t.headerRow ? t.startRow + 1 : t.startRow; r <= t.endRow; r++) {
    let key = '';
    for (let c = t.startCol; c <= t.endCol; c++) {
      key += '|' + getCellValue(r, c);
    }
    if (seen.has(key)) rowsToDelete.add(r);
    else seen.add(key);
  }
  if (rowsToDelete.size === 0) return tables;
  const sorted = [...rowsToDelete].sort((a, b) => b - a);
  // We can't easily delete from gridData here, just return updated table bounds
  return tables.map((table, i) => {
    if (i !== tableIdx) return table;
    let delta = 0;
    for (const rd of sorted) if (rd <= t.endRow - delta) delta++;
    return { ...table, endRow: t.endRow - delta };
  });
}
